export default __webpack_public_path__ + "static/media/chie_horizontal.928d8d72.png";